import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="#fff" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M15.5 7l-6.526 7L5 10l1-1 2.974 3L14.5 6l1 1z" /></svg>;